import { useEffect, useState } from "react"
import Dialog from "../../components/dialog/Dialog";
import { lang, useUrl } from "../../Utils";
import CreatableSelect from 'react-select/creatable';
import { getFavourite, saveFavourite } from "./Services";
import md5 from "blueimp-md5";
import { useBoolean } from "@chakra-ui/react";
import Loader from "../../components/loader/Loader";
import { Button } from "../../components/button/Button";

const FavouriteModal = ({ url, target, isOpen, onClose, onSave, onDelete }) => {

  const [favourite, setFavourite] = useState();
  const [folder, setFolder] = useState({});
  const [newFolder, setNewFolder] = useState();
  const [folders, setFolders] = useState();
  const [loader, setLoader] = useBoolean();

  useEffect(() => {
    setLoader.on();
    getFavourite(md5(url))
      .then((data) => {
        if (!!data?.favourite) {
          setFavourite(data?.favourite);
        } else {
          setFavourite({slug : md5(url), url: url, name : '', target: (target || '_self')});
        }
        setFolders(data?.folders.reduce((arr, value) => arr = [...arr, { value: value.id, label: value.name }], []));
      })
      .finally(_ => setLoader.off());
  }, []);

  const onSelectChange = (selectValue) => setFolder((!!selectValue) ? selectValue : null)
  const onInputChange = (inputValue) => setNewFolder((!!inputValue) ? inputValue : null);

  const handleSave = () => {
    onClose();
    onSave({ ...favourite, folder: (folder || newFolder) })
  }

  const handleDelete = () => {
    onClose();
    onDelete(favourite.id);
  }

  return (
    <Dialog title={lang("Favourite")} isOpen={isOpen} onClose={onClose}>
      {(!loader) ?
        <form className="bf-form">
          <div className="bf-input-group">
            <label>{lang('Name')}</label>
            <input type="text" onChange={(event) => setFavourite(prevState => ({ ...prevState, name: event.target.value }))} value={favourite?.name}></input>
          </div>
          <div className="bf-input-group">
            <label>{lang('Folder')}</label>
            <CreatableSelect
              classNamePrefix="bf-select"
              defaultValue={folders?.filter(folder => folder.value === favourite?.folder_id)?.pop()}
              isClearable
              onChange={onSelectChange}
              onInputChange={onInputChange}
              options={folders}
            />
          </div>
          <div className="bf-input-group" style={{display:'none'}}>
            <label><input type="radio" onChange={(event) => setFavourite(prevState => ({ ...prevState, target: event.target.value }))} value="_self" checked={favourite?.target === '_self'} />{lang('Open in the same window')}</label>
            <label><input type="radio" onChange={(event) => setFavourite(prevState => ({ ...prevState, target: event.target.value }))} value="_new" checked={favourite?.target === '_new'} />{lang('Open in new window')}</label>
          </div>
          
          <div className="bf-modal-actions">
            {(!!favourite?.id) ? <>
              <Button variant="default" onClick={handleSave}>{lang('Edit')}</Button>
              <Button variant="default" onClick={handleDelete}>{lang('Delete')}</Button>
            </> :
              <Button variant="default" onClick={handleSave}>{lang('Save')}</Button>
            }
            <Button variant="default" onClick={onClose}>{lang('Close')}</Button>
          </div>
        </form> : <Loader height={'250px'}/>}
    </Dialog>
  )
}

export default FavouriteModal;